import { api } from "../api";

/**
 * findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse - Function that finds on database all groups by department and status as select list response data  
 * /groups/list/{customerId}/{departmentId}/{status}  
 * method GET  
 * @async-function
 */
const findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse = async (token: string, customerId: number, userId: number, departmentId: number, status: string, ignoreDepartments: boolean = false) => {
    const response = await api.get(
        `/groups/list/${userId}/${customerId}/${departmentId}/${status}?ignoreDepartments=${ignoreDepartments}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse;